<p-toast key="eyeDialog"></p-toast>
<ng-container *ngIf="currentPreviewInvoice; else noData">
	<div class="preview-dialog">
		<div *ngIf="showDocumentProgress" class="document-progress-drawer" [class.document-progress-drawer-rtl]="direction === 'rtl'" [class.document-progress-complete]="isDocumentProgressComplete">
			<div class="document-progress-title">
				<i class="pi pi-list-check"></i>
				<span>{{ translateServ.dictionary['FILE_PROGRESS'] || 'Progress' }}</span>
			</div>
			<strong>{{ documentProgressCurrent }} / {{ documentProgressTotal }}</strong>
			<div class="document-progress-track">
				<div class="document-progress-fill" [style.width.%]="documentProgressPercent"></div>
			</div>
		</div>

		<div class="preview-dialog-header p-d-flex p-ai-center w-full"
			[ngStyle]="direction === 'rtl' ? {'padding-left':'4.5rem','padding-right':'0.5rem','gap':'0.5rem','margin-top':'0.5rem','position':'relative','flexDirection':'row-reverse'} : {'padding-right':'4.5rem','padding-left':'0.5rem','gap':'0.5rem','margin-top':'0.5rem','position':'relative','flexDirection':'row'}">
			<!-- Navigation and title -->
			<ng-container *ngIf="direction === 'ltr'">
				<div style="display: flex; align-items: center; gap: 0.5rem; min-width: 220px;"
					*ngIf="currentPreviewInvoice">
					<button pButton icon="pi pi-angle-left" class="p-button-rounded p-button-text"
						(click)="prevDocument()" [disabled]="!hasPrevDocument"
						pTooltip="{{ translateServ.dictionary['FILE_PREV'] || 'Previous File' }}"></button>
					<span>{{ translateServ.dictionary['FILE_NAV'] || 'File Navigation' }}</span>
					<strong style="min-width: 3.5rem; text-align: center;">
						{{ translateServ.dictionary['CURRENT_FILE'] || 'Current File' }}: {{
						currentPreviewInvoice.FileRecID
						}}
					</strong>
					<button pButton icon="pi pi-angle-right" class="p-button-rounded p-button-text"
						(click)="nextDocument()" [disabled]="!hasNextDocument"
						pTooltip="{{ translateServ.dictionary['FILE_NEXT'] || 'Next File' }}"></button>
				</div>
				<div
					style="display: flex; align-items: center; margin-right: 1rem; gap: 1rem; width: 100%; direction: ltr;">
					<h4 class="p-dialog-title p-m-0" style="margin: 0; order: 1;">
						{{ translateServ.dictionary['JOURNAL_MOVES_PREVIEW_TITLE'] }}
						<span *ngIf="currentPreviewInvoice">
							({{ translateServ.dictionary['MAINT_CS_TIT_ID'] }}: {{ currentPreviewInvoice.ID }})
						</span>
					</h4>

					<span style="flex: 1 1 auto; order: 2;"></span>

					   <span style="display: inline-flex; align-items: center; margin-left: 0.5rem; order: 3;">
						   <button *ngIf="canReassignCurrentFileClassification" pButton type="button" icon="pi pi-truck"
							   class="p-button-text p-button-sm"
							   pTooltip="{{ translateServ.dictionary['STEP_TAB_TIT_CATEGORY'] }}" tooltipPosition="top"
							   (click)="classificationPanel.toggle($event)"></button>
						   <p-overlayPanel #classificationPanel [appendTo]="'body'">
							   <div class="flex flex-column gap-2" style="min-width: 12rem;">
								   <button *ngFor="let option of getReassignClassificationOptions()" pButton type="button"
									   class="p-button-text p-button-sm justify-content-start"
									   (click)="reassignCurrentFileClassification(option, classificationPanel)">
									   <span class="flex align-items-center gap-2">
												   <i *ngIf="getIconClass(option.IconGrade) as iconClass" [class]="iconClass"></i>
										   <span>{{ option.FileGradeClassification }}</span>
									   </span>
								   </button>
							   </div>
						   </p-overlayPanel>
						   <p-button *ngIf="canToggleCurrentFileWorkbench"
							   type="button"
							   [icon]="isCurrentFileInWorkbench ? 'pi pi-box' : 'pi pi-reply'"
							   styleClass="p-button-text p-button-sm"
							   [pTooltip]="isCurrentFileInWorkbench ? translateServ.dictionary['WORKBENCH_IN_MSG'] : translateServ.dictionary['WORKBENCH_ADD_MSG']"
							   tooltipPosition="top"
							   (click)="toggleCurrentFileWorkbench()">
						   </p-button>
						   <ng-container *ngIf="currentPreviewInvoice">
							   <p-tag [icon]="'pi pi-bell'"
								   (click)="!displayNotificationsDialog && openNotificationDialog()"
								   [value]="getNotificationTag(currentPreviewInvoice).value"
								   [severity]="getNotificationTag(currentPreviewInvoice).severity" [rounded]="true"
								   [pTooltip]="getNotificationTag(currentPreviewInvoice).tooltip"
								   [ngStyle]="{'margin-bottom': '0', 'direction': direction, 'order': 3, 'position': 'relative', 'z-index': '10', 'cursor': 'pointer', 'opacity': displayNotificationsDialog ? 0.5 : 1, 'pointer-events': displayNotificationsDialog ? 'none' : 'auto'}">
							   </p-tag>
						   </ng-container>
					   </span>
				</div>
			</ng-container>
			<ng-container *ngIf="direction === 'rtl'">
				<div style="display: flex; align-items: center; gap: 0.5rem; min-width: 220px;"
					*ngIf="currentPreviewInvoice">
					<button pButton icon="pi pi-angle-right" class="p-button-rounded p-button-text"
						(click)="prevDocument()" [disabled]="!hasPrevDocument"
						pTooltip="{{ translateServ.dictionary['FILE_PREV'] || 'Previous File' }}"></button>
					<span>{{ translateServ.dictionary['FILE_NAV'] || 'File Navigation' }}</span>
					<strong style="min-width: 3.5rem; text-align: center;">
						{{ translateServ.dictionary['CURRENT_FILE'] || 'Current File' }}: {{
						currentPreviewInvoice.FileRecID
						}}
					</strong>
					<button pButton icon="pi pi-angle-left" class="p-button-rounded p-button-text"
						(click)="nextDocument()" [disabled]="!hasNextDocument"
						pTooltip="{{ translateServ.dictionary['FILE_NEXT'] || 'Next File' }}"></button>
				</div>
				<div
					style="display: flex; align-items: center; margin-right: 1rem; gap: 1rem; width: 100%; direction: rtl;">
					<h4 class="p-dialog-title p-m-0" style="margin: 0; order: 1;">
						{{ translateServ.dictionary['JOURNAL_MOVES_PREVIEW_TITLE'] }}
						<span *ngIf="currentPreviewInvoice">
							({{ translateServ.dictionary['MAINT_CS_TIT_ID'] }}: {{ currentPreviewInvoice.ID }})
						</span>
					</h4>
					<span style="flex: 1 1 auto; order: 2;"></span>
					   <span style="display: inline-flex; align-items: center; margin-left: 0.5rem; order: 3;">
						   <button *ngIf="canReassignCurrentFileClassification" pButton type="button" icon="pi pi-truck"
							   class="p-button-text p-button-sm"
							   pTooltip="{{ translateServ.dictionary['STEP_TAB_TIT_CATEGORY'] }}" tooltipPosition="top"
							   (click)="classificationPanel.toggle($event)"></button>
						   <p-overlayPanel #classificationPanel [appendTo]="'body'">
							   <div class="flex flex-column gap-2" style="min-width: 12rem;">
								   <button *ngFor="let option of getReassignClassificationOptions()" pButton type="button"
									   class="p-button-text p-button-sm justify-content-start"
									   (click)="reassignCurrentFileClassification(option, classificationPanel)">
									   <span class="flex align-items-center gap-2">
												   <i *ngIf="getIconClass(option.IconGrade) as iconClass" [class]="iconClass"></i>
										   <span>{{ option.FileGradeClassification }}</span>
									   </span>
								   </button>
							   </div>
						   </p-overlayPanel>
						   <p-button *ngIf="canToggleCurrentFileWorkbench"
							   type="button"
							   [icon]="isCurrentFileInWorkbench ? 'pi pi-box' : 'pi pi-reply'"
							   styleClass="p-button-text p-button-sm"
							   [pTooltip]="isCurrentFileInWorkbench ? translateServ.dictionary['WORKBENCH_IN_MSG'] : translateServ.dictionary['WORKBENCH_ADD_MSG']"
							   tooltipPosition="top"
							   (click)="toggleCurrentFileWorkbench()">
						   </p-button>
						   <ng-container *ngIf="currentPreviewInvoice">
							   <p-tag [icon]="'pi pi-bell'"
								   (click)="!displayNotificationsDialog && openNotificationDialog()"
								   [value]="getNotificationTag(currentPreviewInvoice).value"
								   [severity]="getNotificationTag(currentPreviewInvoice).severity" [rounded]="true"
								   [pTooltip]="getNotificationTag(currentPreviewInvoice).tooltip"
								   [ngStyle]="{'margin-bottom': '0', 'direction': direction, 'order': 3, 'position': 'relative', 'z-index': '10', 'cursor': 'pointer', 'opacity': displayNotificationsDialog ? 0.5 : 1, 'pointer-events': displayNotificationsDialog ? 'none' : 'auto'}">
							   </p-tag>
						   </ng-container>
					   </span>
				</div>
			</ng-container>
		</div>
		<!-- Block UI overlay while loading -->
		<div *ngIf="isDialogFullyLoading" class="dialog-loading-overlay">
			<p-progressBar mode="indeterminate"></p-progressBar>
		</div>
		<div class="preview-dialog-content-wrapper p-d-flex" [class.dialog-blur]="isDialogFullyLoading">
			<div class="invoice-details-panel" style="flex: 1 1 40%; max-width: 40%; display: flex; flex-direction: column; min-height: 0;">
				<div class="panel-scroll" style="flex: 1 1 0; overflow-y: auto; overflow-x: hidden; min-height: 0;">
					<p-tabView (onChange)="onTabChange($event)" [(activeIndex)]="activeTab">
						<p-tabPanel header="{{ translateServ.dictionary['PREV_JOURNAL_MOVE_DETAILS'] }}">
							<ng-template pTemplate="content">
								<div *ngIf="isJournalsLoading" class="p-py-4">
									<p-progressBar mode="indeterminate"></p-progressBar>
								</div>
								<ng-container *ngIf="!isJournalsLoading">
								<ng-container *ngIf="journalLines.length > 0; else noJournalsTpl">
								<!-- Fixed header: edit buttons + journal navigation -->
								<div class="journal-tab-fixed">
								<!-- Edit button for journals -->
								<div class="p-mb-3" style="display: flex; align-items: center; gap: 1rem;">
									<p-button *ngIf="isEditAllowed && !isEditingPreviewJR"
										label="{{ translateServ.dictionary['PREV_BTN_EDIT'] }}" icon="pi pi-pencil"
										styleClass="p-button-outlined p-button-sm"
										(click)="editPreview('JR')"></p-button>
									<ng-container *ngIf="isEditingPreviewJR">
										<p-button label="{{ translateServ.dictionary['PRE_BTN_CANCEL'] }}"
											icon="pi pi-times"
											styleClass="p-button-outlined p-button-sm p-button-danger p-mr-2"
											(click)="cancelEditPreview('JR')"></p-button>
										<p-button label="{{ translateServ.dictionary['PREV_BTN_SAVE'] }}"
											icon="pi pi-check" styleClass="p-button-sm" (click)="savePreview('JR')"
											[loading]="isSavingPreview"></p-button>
									</ng-container>

									
									<p-button *ngIf="isEditAllowed"
										type="button"
										[label]="loadIsJournalChecked(currentPreviewInvoice.FileRecID, currentPreviewInvoice.ID) ? (translateServ.dictionary['WILL_GO_TO_MOVEIN']) : (translateServ.dictionary['WONT_GO_TO_MOVEIN'])"
										[icon]="loadIsJournalChecked(currentPreviewInvoice.FileRecID, currentPreviewInvoice.ID) ? 'pi pi-check-circle' : 'pi pi-circle-off'"
										[ngClass]="{
											'p-button-success': loadIsJournalChecked(currentPreviewInvoice.FileRecID, currentPreviewInvoice.ID),
											'p-button-secondary': !loadIsJournalChecked(currentPreviewInvoice.FileRecID, currentPreviewInvoice.ID),
											'p-button-text': true,
											'p-button-sm': true
										}"
										(onClick)="toggleCurrentJournalExportStatus()"
										[pTooltip]="loadIsJournalChecked(currentPreviewInvoice.FileRecID, currentPreviewInvoice.ID) ? (translateServ.dictionary['WILL_GO_TO_MOVEIN_MSG']) : (translateServ.dictionary['WONT_GO_TO_MOVEIN_MSG'])"
										tooltipPosition="top"
										[style]="{'margin-left': '0.5rem', 'min-width': '180px'}">
									</p-button>
								</div>

								<div class="p-d-flex p-jc-center p-ai-center p-mb-3 w-full" style="gap: 1rem;">
									<ng-container *ngIf="direction === 'ltr'; else rtlNav">
										<button pButton icon="pi pi-chevron-left" class="p-button-rounded p-button-text"
											(click)="prevJournal()" [disabled]="!hasPrev"></button>

										<strong>{{ currentJournalIndex + 1 }} / {{ journalLines.length }}</strong>
										<button pButton icon="pi pi-chevron-right"
											class="p-button-rounded p-button-text" (click)="nextJournal()"
											[disabled]="!hasNext"></button>
									</ng-container>

									<ng-template #rtlNav>
										<button pButton icon="pi pi-chevron-right"
											class="p-button-rounded p-button-text" (click)="prevJournal()"
											[disabled]="!hasPrev"></button>

										<strong>{{ currentJournalIndex + 1 }} / {{ journalLines.length }}</strong>

										<button pButton icon="pi pi-chevron-left" class="p-button-rounded p-button-text"
											(click)="nextJournal()" [disabled]="!hasNext"></button>
									</ng-template>

								</div>
								</div>
								<!-- end journal-tab-fixed -->

								<!-- Scrollable body: journal field list -->
								<div class="journal-tab-scroll">
								<div *ngIf="currentPreviewInvoice">
									<div *ngFor="let colField of allColumnFields; let i = index" class="detail-item">
										<ng-container
											*ngIf="!hideEmptyColumnsInPreviewEnabled || (currentPreviewInvoice[colField] !== null && currentPreviewInvoice[colField] !== '' && currentPreviewInvoice[colField] !== undefined)">
											<strong class="detail-label">
												{{ getColumnHeader(colField) }}:
												<span *ngIf="recentlyUpdatedFields.includes(colField)"
													class="blinking-flag" title="Updated">
													<i class="pi pi-flag-fill"></i>
												</span>
											</strong>
											<span class="detail-value">
												<ng-container
													*ngIf="isEditingPreviewJR && editableInvoice && isFieldEditable(colField); else viewJournalValue">
													<div
														style="display: flex; flex-direction: column; align-items: flex-start; width: 100%;">
														<ng-container [ngSwitch]="getFieldConfig(colField)?.type">
															<ng-container *ngSwitchCase="'date'">
																<p-inputMask [(ngModel)]="editableInvoice[colField]"
																	mask="99/99/9999"
																	placeholder="dd/mm/yyyy"
																	styleClass="w-full"
																	[disabled]="!isFieldEditable(colField)">
																</p-inputMask>
															</ng-container>
															<ng-container *ngSwitchCase="'autocomplete'">
																<p-autoComplete [(ngModel)]="editableInvoice[colField]"
																	(ngModelChange)="onAutoCompleteModelChange(colField, $event)"
																	[suggestions]="autoCompleteOptions[colField]"
																	(completeMethod)="onAutoCompleteSearch($event, colField)"
																	(onFocus)="onAutoCompleteFocus(colField)"
																	(onSelect)="onAutoCompleteSelect(colField, $event)"
																	(onBlur)="onAutoCompleteBlur(colField)"
																	[field]="'label'" [dropdown]="true"
																	[forceSelection]="false"
																	[disabled]="!isFieldEditable(colField)"
																	[inputStyle]="{width: '100%', minWidth: '200px', maxWidth: '500px', overflowX: 'auto', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}"
																	[panelStyle]="{minWidth: '400px', maxWidth: '700px', overflowX: 'auto'}"
																	[placeholder]="'Select...'" [appendTo]="'body'"
																	[minLength]="0"
																	[virtualScroll]="useVirtualScrollForField(colField)"
																	[virtualScrollItemSize]="36" [autoHighlight]="true"
																	[showClear]="false"
																	[dropdownIcon]="'pi pi-chevron-down'"
																	[inputId]="colField + '-autocomplete'">
																	<ng-template pTemplate="item" let-item>
																		<div (mousedown)="onAutoCompleteItemMouseDown(colField, item, $event)"
																			style="display: block; width: 100%; padding: 0.15rem 0; cursor: pointer;">
																			<span
																				style="display: block; white-space: normal; word-break: break-word; width: 100%; line-height: 1.5rem;"
																				[title]="item.label">
																				{{ item.label }}
																			</span>
																			</div>
																		</ng-template>
																	</p-autoComplete>
																<!-- Open additional dialog icon (visible when configured and value present) -->
																<ng-container *ngIf="shouldShowOpenIcon(colField)">
																	<ng-container *ngIf="getOpenAdditionalDialogConfig(colField) as openCfg; else iconOnly">
																		<button pButton type="button"
																			(click)="openAdditionalDialogForField(colField)"
																			[icon]="getOpenIcon(colField)"
																			[label]="translateServ.dictionary[openCfg.transValue] || openCfg.transValue"
																			[iconPos]="direction === 'rtl' ? 'right' : 'left'"
																			class="p-button-text p-button-rounded p-button-sm">
																		</button>
																	</ng-container>
																	<ng-template #iconOnly>
																		<button pButton type="button" (click)="openAdditionalDialogForField(colField)" [icon]="getOpenIcon(colField)" [iconPos]="direction === 'rtl' ? 'right' : 'left'" class="p-button-text p-button-rounded p-button-sm"></button>
																	</ng-template>
																</ng-container>
															</ng-container>
															<ng-container *ngSwitchCase="'money'">
																<p-inputNumber mode="decimal"
																			  [minFractionDigits]="2"
																			  [maxFractionDigits]="3"
																			  [(ngModel)]="editableInvoice[colField]"
																			  class="w-full"
																			  [inputStyle]="{width: '100%'}"
																			  [disabled]="!isFieldEditable(colField)"
																			  (onBlur)="onFieldBlur(colField)">
																	</p-inputNumber>
															</ng-container>
															<ng-container *ngSwitchDefault>
																<input pInputText type="text"
																	[(ngModel)]="editableInvoice[colField]"
																	class="w-full"
																	[pKeyFilter]="getKeyFilterForField(colField)"
																	(keypress)="restrictToNumberInput($event, colField)"
																	(blur)="onFieldBlur(colField)"
																	[disabled]="!isFieldEditable(colField)">
															</ng-container>
														</ng-container>
														<small *ngIf="isJournalFieldChanged(colField)"
															class="text-secondary"
															style="display:block; margin-top:0.25rem;">
															{{ translateServ.dictionary['ORIGINAL_VALUE'] || 'Original
															value' }}:
															{{ getOriginalJournalFieldDisplayValue(colField) }}
														</small>
													</div>
												</ng-container>

												<ng-template #viewJournalValue>
													<ng-container *ngIf="colField === 'MT'; else defaultViewOnly">
														<p-tag [value]="getMtDisplayText(currentPreviewInvoice.MT)"
															[severity]="getMtSeverity(currentPreviewInvoice.MT)"></p-tag>
													</ng-container>
													<ng-template #defaultViewOnly>
														<!-- Always show the current value from editableInvoice if available -->
														<ng-container
															*ngIf="getFieldConfig(colField)?.type === 'date'; else normalValueDisplay">
														{{ getDateFieldDisplayValue(editableInvoice && editableInvoice[colField] !==
														undefined ? editableInvoice[colField] :
														(currentPreviewInvoice ? currentPreviewInvoice[colField] :
														'')) }}
														</ng-container>
														<ng-template #normalValueDisplay>
															{{ editableInvoice && editableInvoice[colField] !==
															undefined ? editableInvoice[colField] :
															(currentPreviewInvoice ? currentPreviewInvoice[colField] :
															'') }}
														</ng-template>
													</ng-template>
												</ng-template>
											</span>
										</ng-container>
									</div>
								</div>

								<div *ngIf="!currentPreviewInvoice" class="p-text-center p-py-5">
									<i class="pi pi-info-circle p-text-blue-500" style="font-size: 3rem;"></i>
									<p class="p-mt-3">{{ translateServ.dictionary['PREV_NO_JMD_TO_DISPLAY'] }}.</p>
								</div>
								</div>
								<!-- end journal-tab-scroll -->
								</ng-container>

								<ng-template #noJournalsTpl>
									<div style="display:flex; flex-direction:column; align-items:center; justify-content:center; padding: 3rem 1rem; text-align:center;">
										<i class="pi pi-exclamation-triangle" style="font-size: 3rem; color: #d32f2f;"></i>
										<p style="margin-top:1rem; font-weight:600; font-size:1.1rem; color: #d32f2f;">
											{{ translateServ.dictionary['FILE_HAS_NO_JOR']}}
										</p>
										<p style="margin-top:0.5rem; max-width: 28rem; color: var(--text-color-secondary); line-height:1.5;">
											{{ translateServ.dictionary['FILE_HAS_NO_JOR_EXP']}}
										</p>
									</div>
								</ng-template>
								</ng-container>
							</ng-template>
						</p-tabPanel>

						<p-tabPanel header="{{ translateServ.dictionary['PREV_EXTRACTED_DATA'] }}">
							<ng-template pTemplate="content">
								<div class="extracted-tab-fixed">
								<div class="p-mb-3">
									<p-button *ngIf="isEditAllowed && !isEditingPreviewFF"
										label="{{ translateServ.dictionary['PREV_BTN_EDIT'] }}" icon="pi pi-pencil"
										styleClass="p-button-outlined p-button-sm"
										(click)="editPreview('FF')"></p-button>
									<ng-container *ngIf="isEditingPreviewFF">
										<p-button label="{{ translateServ.dictionary['PRE_BTN_CANCEL'] }}"
											icon="pi pi-times"
											styleClass="p-button-outlined p-button-sm p-button-danger p-mr-2"
											(click)="cancelEditPreview('FF')"></p-button>
										<p-button label="{{ translateServ.dictionary['PREV_BTN_SAVE'] }}"
											icon="pi pi-check" styleClass="p-button-sm" (click)="savePreview('FF')"
											[loading]="isSavingPreview"></p-button>
									</ng-container>
								</div>
								</div>
								<div class="extracted-tab-scroll">
								<div class="feature-comparison-table-container">
									<p-progressBar *ngIf="isFeatureDataLoading" mode="indeterminate"></p-progressBar>
									<div *ngIf="!isFeatureDataLoading && featureComparisonData.length > 0"
										class="feature-comparison-table">
										<div class="feature-table-header p-d-flex">
											<div class="header-col"
												[ngStyle]="{'text-align': direction === 'rtl' ? 'right' : 'left'}">{{
												translateServ.dictionary['PREV_JMD_HEADER_FEATURE'] }}</div>
											<div class="header-col">{{
												translateServ.dictionary['PREV_JMD_HEADER_BEFORE_CHG'] }}</div>
											<div class="header-col"></div>
											<div class="header-col">{{
												translateServ.dictionary['PREV_JMD_HEADER_AFTER_CHG']
												}}</div>
										</div>
										<div class="feature-table-body">
											<div *ngFor="let feature of featureComparisonData"
												class="feature-table-row p-d-flex">
												<div class="feature-name"
													[ngStyle]="{'text-align': direction === 'rtl' ? 'right' : 'left'}">
													{{
													feature.Feature }}</div>
												<div class="feature-value-before">{{ feature.FeatureValue ?? '' }}</div>
												<div class="feature-arrow p-d-flex p-jc-center p-ai-center">
													<i class="pi pi-flag-fill p-mr-1"
														[ngClass]="{'text-green-500': getStringValue(feature.FeatureValue) === getStringValue(feature.FeatureValueStd),
																'text-yellow-500': getStringValue(feature.FeatureValue) !== getStringValue(feature.FeatureValueStd)}"></i>
												</div>
												<div class="feature-value-after p-dflex p-ai-center">
													<ng-container *ngIf="isEditingPreviewFF; else viewExtractedData">
														<ng-container
															*ngIf="paymentFeatures.includes(feature.Feature1); else normalInput">
															<div class="p-inputgroup w-full">
																<input pInputText type="text"
																	[(ngModel)]="feature.FeatureValueStd" class="w-full"
																	pattern="^[0-9]*[.,]?[0-9]{0,2}$"
																	[pKeyFilter]="getKeyFilterForField(feature.Feature1)"
																	(keypress)="restrictToNumberInput($event, feature.Feature1)"
																	(focus)="onPaymentFeatureEdit(feature.Feature1)"
																	(blur)="onPaymentFeatureBlur()">
																<span class="p-inputgroup-addon"
																	style="padding:0; background:transparent; border:none;">
																	<button pButton type="button" icon="pi pi-refresh"
																		pTooltip="{{ translateServ.dictionary['RECALC_TOOLTIP'] || 'Recalculate' }}"
																		tooltipPosition="top"
																		(mousedown)="$event.preventDefault()"
																		(click)="onRecalcPaymentFeature(feature.Feature1)"
																		class="p-button-secondary p-button-sm"
																		style="margin:0; padding:0 0.5rem;"></button>
																</span>
															</div>
														</ng-container>
														<ng-template #normalInput>
															<input pInputText type="text"
																[(ngModel)]="feature.FeatureValueStd" class="w-full"
																[pKeyFilter]="getKeyFilterForField(feature.Feature1)"
																(keypress)="restrictToNumberInput($event, feature.Feature1)"
																(focus)="onPaymentFeatureEdit(feature.Feature1)"
																(blur)="onPaymentFeatureBlur()">
														</ng-template>
													</ng-container>
													<ng-template #viewExtractedData>
														{{ feature.FeatureValueStd ?? '' }}
													</ng-template>
												</div>
											</div>
										</div>
									</div>
									<div *ngIf="!isFeatureDataLoading && featureComparisonData.length === 0"
										class="p-text-center p-py-5">
										<i class="pi pi-info-circle p-text-blue-500" style="font-size: 3rem;"></i>
										<p class="p-mt-3">{{ translateServ.dictionary['PREV_NO_FEATURE_TO_DISPLAY'] }}.
										</p>
									</div>
								</div>
								</div>
							</ng-template>
						</p-tabPanel>
					</p-tabView>
				</div>
			</div>

			<div class="file-preview-panel"
				style="flex: 1 1 60%; max-width: 70%; display:flex; flex-direction:column; min-height:0;">
				<ng-container *ngIf="currentPreviewUrl && (isPreviewPdf || isPreviewImage)">
					<div class="file-preview-content"
						style="flex:1 1 auto; overflow:auto; display:flex; align-items:center; justify-content:center;">
						<embed *ngIf="isPreviewPdf" [src]="currentPreviewUrl" type="application/pdf" width="100%"
							height="100%">
						<img *ngIf="isPreviewImage" [src]="currentPreviewUrl"
							alt="{{ translateServ.dictionary['JOURNAL_MOVES_PREVIEW_TITLE'] }}"
							style="max-width: 100%; max-height: 100%; object-fit: contain;">
					</div>
				</ng-container>
				<div *ngIf="!currentPreviewUrl && !errorMessage" class="p-text-center p-py-5">
					<i class="pi pi-file p-text-4xl p-text-blue-500"></i>
					<p class="p-mt-3">{{ translateServ.dictionary['NO_FILES_FOUND'] }}.</p>
				</div>
				<p-progressBar *ngIf="loading" mode="indeterminate"></p-progressBar>
			</div>

		</div>

		<!-- end preview-dialog-content-wrapper -->

		<ng-template pTemplate="footer">
			<div class="p-d-flex p-jc-start w-full">
				<!-- Tab 2 (Extracted Data) Edit/Save/Cancel -->
				<p-button *ngIf="isEditAllowed && !isEditingPreviewFF && activeTab === 1"
					label="{{ translateServ.dictionary['PREV_BTN_EDIT'] }}" icon="pi pi-pencil"
					styleClass="p-button-outlined p-button-sm" (click)="editPreview('FF')"></p-button>

				<ng-container *ngIf="isEditingPreviewFF && activeTab === 1">
					<p-button label="{{ translateServ.dictionary['PRE_BTN_CANCEL'] }}" icon="pi pi-times"
						styleClass="p-button-outlined p-button-sm p-button-danger p-mr-2"
						(click)="cancelEditPreview('FF')"></p-button>

					<p-button label="{{ translateServ.dictionary['PREV_BTN_SAVE'] }}" icon="pi pi-check"
						styleClass="p-button-sm" (click)="savePreview('FF')" [loading]="isSavingPreview"></p-button>
				</ng-container>
			</div>
		</ng-template>

	</div>


	<!-- Notification Dialog Component -->
	<app-notification-dialog [fileRecId]="currentFileRecIdForNotification" [(visible)]="displayNotificationsDialog"
		(notificationSummaryChange)="onNotificationSummaryChange($event)">
	</app-notification-dialog>

	<ng-template #noData>
		<div style="padding:2rem; text-align:center; color: red;">
			No data provided to dialog.
		</div>
	</ng-template>